import { Apis } from "../../lib/Apis";

export const usePricing = () => {
    const getPricing = async (setPricingList) => {
        try {
            const response = await Apis.getPricing();
            if (response.status === 200) {
                setPricingList(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch pricing list:", error);
            setPricingList([]);
        }
    };
    const addPricing = async (data) => {
        try {
            const response = await Apis.createPricing(data);
            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            throw new Error("Failed to add pricing data.");
        }
    };
    const updatePricing = async (id, data) => {
        try {
            const response = await Apis.updatePricing(id, data);
            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            throw new Error("Failed to update pricing data.");
        }
    };
    const deletePricing = async (id) => {
        try {
            const response = await Apis.deletePricing(id);
            if (response.status === 200) {
                return response.data;
            }
        } catch (error) {
            throw new Error("Failed to delete pricing data.");
        }
    };

    return {
        getPricing,
        addPricing,
        updatePricing,
        deletePricing,
    };
};
